import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '../http/http.service';
import { API_CONFIG } from '../crud/api.config';

/** Datos del perfil propio (persona USUARIO ligada a la identidad por el username del JWT). */
export interface PerfilData {
  id: number;
  username: string;
  tipoDocumentoCodigo?: string;
  numeroDocumento?: string;
  nombres?: string;
  apellidos?: string;
  email?: string;
  estadoUsuario?: string;
}

/**
 * Acceso a datos del PERFIL propio (autoservicio) sobre nebula-masters
 * `/api/v1/usuario/mi-perfil`. Vive en data-access (no en ui) para que lo consuman tanto el modal
 * de perfil como el menú del header (layout ya depende de data-access; así el layout no arrastra
 * una dependencia estática a `@nebula-shared/ui`, que rompería su build ng-packagr). El backend
 * resuelve por el username del JWT y solo aplica nombres/apellidos/correo en la actualización.
 */
@Injectable({ providedIn: 'root' })
export class PerfilService {
  private readonly http = inject(HttpService);
  private readonly baseUrl = `${API_CONFIG.masters.baseUrl}/usuario`;

  /** Carga el perfil del usuario autenticado. */
  getMiPerfil(): Observable<PerfilData> {
    return this.http.getContent<PerfilData>(`${this.baseUrl}/mi-perfil`);
  }

  /** Actualiza el perfil propio (el backend solo aplica nombres/apellidos/correo). */
  actualizarMiPerfil(dto: PerfilData): Observable<PerfilData> {
    return this.http
      .put<PerfilData>(`${this.baseUrl}/mi-perfil`, dto)
      .pipe(map((response) => response?.response?.content as PerfilData));
  }
}
